/* eslint-disable */
import React, { useState } from "react";
import { Button, Card, Typography, Box, Radio, RadioGroup, FormControlLabel, useTheme, Container, Grid, CircularProgress, Tooltip } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { useLocation, useNavigate } from "react-router";
import { useMutation } from "@apollo/client";
import EditIcon from "../../Images/edit-icon.svg";
import AiGeneratePopup from "../Modal/AiGeneratePopup";
import { getTextMetrics } from "../../utils/myUtills";
import { SectionWrapper } from "./AiBlogWriter";
import StepProgress from "./StepProgress";
import { GENERATE_PARAGRAPH, GENERATE_TITLE } from "../../gql/mutations/keyword";
import { validateString } from "../../utils/validations";
import { handleParagraphGenerate, handleTitleGenerate, highlightKeyword } from "../../utils/blogUtils";
import { usePopup } from "../../context/commonPop";

function BlogTitles() {
  const location = useLocation();
  const navigate = useNavigate();
  const stateData = location.state;
  const [formState, setFormState] = useState({
    keyword: stateData?.formsState?.keyword,
    selectedTitle: stateData?.formsState?.selectedTitle,
    selectedParagraph: stateData?.formsState?.selectedParagraph,
    language: stateData?.formsState?.language || "English",
    count: stateData?.formsState?.count,
    loading: stateData?.formsState?.loading,
    isCheckedTitle: stateData?.formsState?.isCheckedTitle,
    isCheckedParagraph: stateData?.formsState?.isCheckedParagraph,
  });
  const [titles, setTitles] = useState(stateData?.title || []);
  const [activeStep, setActiveStep] = useState(stateData?.activeSteps);
  const [paragraph, setParagraph] = useState([]);
  const [generateParagraph] = useMutation(GENERATE_PARAGRAPH);
  const [generateTitle] = useMutation(GENERATE_TITLE);
  const { handleOpen } = usePopup();
  const [open, setOpen] = useState(false);
  const [selectedTitle, setSelectedTitle] = useState("");
  const [errorState, setErrorState] = useState({
    keyword: false,
  });

  const [writeMoreTilesLoading, setWriteMoreTilesLoading] = useState(false);
  const [regenerateLoading, setRegenerateLoading] = useState(false);
  const [generateParagraphloading, setGenerateParagraphLoading] = useState(false);
  const checkError = async () => {
    const keyword = validateString(formState.keyword);
    setErrorState({
      ...errorState,
      keyword,
    });
    if (keyword) {
      return true;
    }
    return false;
  };

  const handleOpens = title => {
    setSelectedTitle(title);
    setOpen(true);
  };

  const handleState = () => {
    setFormState({ keyword: "", language: "English", count: 1, loading: false });
  };
  const handleRadioChange = e => {
    const { name, value } = e.target;
    setFormState(prev => ({ ...prev, [name]: value, isCheckedTitle: false }));
  };

  const handleTitleUpdate = updatedTitle => {
    const { word_count, character_count } = getTextMetrics(updatedTitle);
    setTitles(prevTitles => prevTitles.map(item => (item.title === selectedTitle ? { title: updatedTitle, word_count, character_count } : item)));
    setOpen(false);
  };

  const theme = useTheme();
  return (
    <SectionWrapper>
      <Container maxWidth="">
        <Box sx={{ flexGrow: 1 }}>
          <Card sx={{ padding: "18px 14px 18px 14px", border: `1px solid ${theme.palette.divider}`, boxShadow: "none !important", overflow: "visible" }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={{ position: "sticky", left: "0", top: "53px", zIndex: 999999 }}>
                <StepProgress activeStep={activeStep} formState={formState} />
              </Grid>
              <Grid item xs={12}>
                <Box className="BestRepresent">
                  <Card sx={{ padding: "20px 14px 14px 14px", border: `1px solid ${theme.palette.divider}`, boxShadow: "none !important" }}>
                    <Typography className="representsHeading" component="h2">
                      Choose a title that best represents your page.
                    </Typography>
                    <RadioGroup name="selectedTitle" value={formState.selectedTitle} onChange={handleRadioChange}>
                      {titles.map((item, index) => (
                        <Box className="representContentBox" key={index + 1}>
                          <Box className="InnerContent">
                            <FormControlLabel
                              value={item.title}
                              control={<Radio className="radioBtn" />}
                              className="radioGroupBox"
                              label={
                                <Box>
                                  <Typography component="h3">{highlightKeyword(item.title, formState.keyword)}</Typography>
                                  <Typography variant="body2">
                                    {item.word_count} words / {item.character_count} characters
                                  </Typography>
                                </Box>
                              }
                            />
                          </Box>
                          <Button className="editBtn" onClick={() => handleOpens(item.title)} disabled={formState.loading}>
                            <Typography component="img" src={EditIcon} alt="" />
                          </Button>
                        </Box>
                      ))}
                    </RadioGroup>
                    <Box className="BtnGroup">
                      <Tooltip
                        title={`Click to generate ${stateData?.formsState?.count} more titles based on your selection.`}
                        placement="top"
                        PopperProps={{
                          sx: {
                            "& .MuiTooltip-tooltip": {
                              mb: "10px !important",
                              textAlign: "center",
                            },
                          },
                        }}
                      >
                        <Button
                          className="moreTitle"
                          onClick={async e => {
                            setWriteMoreTilesLoading(true);
                            await handleTitleGenerate({
                              e,
                              isRegenerate: false,
                              formState,
                              setFormState,
                              generateTitle,
                              titles,
                              setTitles,
                              setActiveStep,
                              handleOpen,
                              checkError,
                              handleState,
                              navigate,
                              type: "title",
                            });
                            setWriteMoreTilesLoading(false);
                          }}
                          disabled={writeMoreTilesLoading || regenerateLoading || generateParagraphloading}
                        >
                          {writeMoreTilesLoading ? (
                            <CircularProgress size={20} />
                          ) : (
                            <>
                              <AutoAwesomeIcon /> Write More Titles
                            </>
                          )}
                        </Button>
                      </Tooltip>
                      <Button
                        className="moreTitle"
                        onClick={async e => {
                          setRegenerateLoading(true);
                          await handleTitleGenerate({
                            e,
                            isRegenerate: true,
                            formState,
                            setFormState,
                            generateTitle,
                            titles,
                            setTitles,
                            setActiveStep,
                            handleOpen,
                            checkError,
                            handleState,
                            navigate,
                            type: "title",
                          });
                          setRegenerateLoading(false);
                        }}
                        disabled={regenerateLoading || writeMoreTilesLoading || generateParagraphloading}
                      >
                        {regenerateLoading ? (
                          <CircularProgress size={20} />
                        ) : (
                          <span>
                            <RefreshIcon /> Re-Generate All
                          </span>
                        )}
                      </Button>
                    </Box>

                    <Box className="BottomBtnGroup">
                      <Button
                        className="BackBtn"
                        disabled={generateParagraphloading || regenerateLoading || writeMoreTilesLoading || formState?.loading}
                        onClick={() => {
                          navigate("/ai-blog-generator");
                        }}
                      >
                        Go Back
                      </Button>
                      <Button
                        className="generateIntro"
                        onClick={async e => {
                          setRegenerateLoading(false);
                          setGenerateParagraphLoading(true);
                          setWriteMoreTilesLoading(false);
                          await handleParagraphGenerate({
                            e,
                            isRegenerate: false,
                            formState,
                            setFormState,
                            generateParagraph,
                            paragraph,
                            titles,
                            setParagraph,
                            setActiveStep,
                            handleOpen,
                            navigate,
                            type: "paragraph",
                          });
                          setGenerateParagraphLoading(false);
                        }}
                        disabled={formState.isCheckedTitle || generateParagraphloading || regenerateLoading || writeMoreTilesLoading}
                      >
                        {generateParagraphloading ? <CircularProgress size={20} /> : "Generate Intro paragraph"}
                      </Button>
                    </Box>
                  </Card>
                  <AiGeneratePopup open={open} setOpen={setOpen} titleText={selectedTitle} setTitleText={handleTitleUpdate} />
                </Box>
              </Grid>
            </Grid>
          </Card>
        </Box>
      </Container>
    </SectionWrapper>
  );
}

export default BlogTitles;
